import { useMemo } from 'react';
import { SUPPORTED_GROUPS_TYPES } from '../../common/constants.tsx';
import { useIssueFields } from '../get-issue-fields/index.tsx';

export const useSupportedFieldIds = () => {
	const { getQueryFieldIds, getAvailableFields } = useIssueFields();
	const queryFieldIds = getQueryFieldIds();

	return useMemo(
		() => [
			...queryFieldIds,
			...getAvailableFields()
				.filter((field) =>
					field.type
						? !queryFieldIds.includes(field.id) && SUPPORTED_GROUPS_TYPES.includes(field.type)
						: false,
				)
				.map((field) => field.id),
		],
		[getAvailableFields, queryFieldIds],
	);
};
